var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gl-flex gl-items-center"},[_c('ci-icon',{staticClass:"gl-leading-0",attrs:{"size":_vm.iconSize,"status":_vm.status,"show-tooltip":false,"use-link":false}}),_vm._v(" "),_c('span',{staticClass:"gl-line-clamp-2 gl-pl-3 gl-wrap-anywhere",attrs:{"title":_vm.name}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }